import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { ROUTES } from '../constants';

export default function PublicRoute() {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated) {
    const redirectTo = user?.role === 'owner' ? ROUTES.HORSE_OWNER_HOME : ROUTES.HORSE_RIDER_HOME;
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
}
